import {
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UtilService } from '@services';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
  public isSideBarClosed!: boolean;
  public subscription: Subscription = new Subscription();
  public innerWidth = window.innerWidth;

  constructor(
    private readonly router: Router,
    private utilService: UtilService,
  ) {}

  ngOnInit(): void {
    this.isSideBarClosed = window.innerWidth < 790 ? true : false;
  }

  public onMenuToggle(event): void {
    this.isSideBarClosed = event;
    this.utilService.sidebarClose.next(event);
  }

  public navigateToCoPaySchedule(): void {
    this.router.navigateByUrl('/management/copaySchedule');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
